import { render, staticRenderFns } from "./OthersProfile.vue?vue&type=template&id=86e808ee&scoped=true&"
import script from "./OthersProfile.vue?vue&type=script&lang=js&"
export * from "./OthersProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e808ee",
  null
  
)

export default component.exports